<curafida-card
    (setActionButton)="addNewPlanTemplate()"
    [actionButtons]="actionButtons()"
    [areButtonsVisible]="!hideEditButtons()"
    [title]="'TASK.PLAN.PLURAL'"
    class="full-width no-left-right-margin">
    <ion-card-content>
        @for (table of lazyLoadedList.list.items; track table.id; let i = $index) {
            <div>
                @if (i > 0) {
                    <div style="margin-top: 20px"></div>
                }
                <div class="task-header">
                    <div style="font-weight: bold">{{ table.title }}</div>
                    @if (!hideEditButtons()) {
                        <ion-button
                            (click)="presentActionButtons($event, table)"
                            fill="clear"
                            data-test-id="open-action-popover-1234asdf"
                            slot="icon-only">
                            <ion-icon name="ellipsis-vertical"></ion-icon>
                        </ion-button>
                    }
                </div>
                <curafida-table
                    [isLoading]="loadingState()"
                    [listTableConfig]="table?.config"></curafida-table>
            </div>
        }
        @if (!lazyLoadedList.hasItems() && loadingState().success) {
            <div style="white-space: pre-wrap">{{ 'TASK.PLAN.ANY_ASSIGN' | translate }}</div>
        }
    </ion-card-content>
</curafida-card>
@if (lazyLoadedList.hasMoreItems()) {
    <ion-infinite-scroll
        (ionInfinite)="nextItems($event)"
        threshold="100px">
        <ion-infinite-scroll-content
            loadingSpinner="crescent"
            loadingText="">
        </ion-infinite-scroll-content>
    </ion-infinite-scroll>
}
